import React from 'react';
import { useTranslation } from 'react-i18next';
import { Eye, LogOut } from 'lucide-react';

/**
 * Shown when an admin is impersonating a user (a backup admin token exists).
 * Clicking "Exit" restores the admin token and returns to the admin panel.
 */
export const ImpersonationBanner = () => {
  const { t } = useTranslation();
  const adminToken = typeof localStorage !== 'undefined' ? localStorage.getItem('kiteiq_admin_token') : null;
  const impName = typeof localStorage !== 'undefined' ? localStorage.getItem('kiteiq_imp_name') : null;
  if (!adminToken) return null;

  const exit = () => {
    localStorage.setItem('kiteiq_token', adminToken);
    // Restore the admin's refresh token (so silent refresh works again).
    const adminRefresh = localStorage.getItem('kiteiq_admin_refresh');
    if (adminRefresh) localStorage.setItem('kiteiq_refresh', adminRefresh);
    else localStorage.removeItem('kiteiq_refresh');
    localStorage.removeItem('kiteiq_admin_token');
    localStorage.removeItem('kiteiq_admin_refresh');
    localStorage.removeItem('kiteiq_imp_name');
    window.location.href = '/admin';
  };

  return (
    <div
      className="sticky top-0 z-[300] flex items-center justify-center gap-3 bg-[#FFB020] px-4 py-2 text-sm font-medium text-black"
      data-testid="impersonation-banner"
    >
      <Eye className="w-4 h-4 shrink-0" />
      <span className="truncate">{t('admin.impersonatingAs', { name: impName || 'user' })}</span>
      <button
        onClick={exit}
        className="ml-1 inline-flex items-center gap-1.5 rounded-md bg-black/85 px-2.5 py-1 text-xs font-semibold text-white transition-colors hover:bg-black"
        data-testid="impersonation-exit-btn"
      >
        <LogOut className="w-3.5 h-3.5" /> {t('admin.exitImpersonation')}
      </button>
    </div>
  );
};
